export default {
  subtitle: "",
  path: "getting_bank_accounts_authorized",
  paragraphs: [
   "You can query the same endpoint with the request id you got on the POST call, so the created bank account information is also retrieved: "
  ],
  request:  {
    method: "GET",
    endpoint: "/bank/accounts/request/:id",
    responses: { 
        "data": { 
           "user_id": "5e018c08-8a3f-43fd-93cf-11f27ba419e2", 
           "subject_id": "93de033d-78db-42f3-9fb6-d2b0abb9a95e", 
           "is_subject_account_owner": false, 
           "status": "complete", 
           "id": "a6a7a710-2bb6-4261-8d56-e7d1a95e6f2b", 
           "errors": null, 
           "bank_account": { 
              "pix_info": { 
              "type": "EVP", 
              "key": "e55eeo1d-01ef-016e-14d0-a1ea701ae17e" 
              }, 
           "owner_name": "FACILITA INSTITUICAO DE PAGAMENTO S/A", 
           "owner_document_type": "cnpj", 
           "owner_document_number": "10789035000105", 
           "id": "edfd9dd6-08c0-4ad7-88bc-dce3810d633e", 
           "currency": "BRL", 
           "branch_number": "0001", 
           "branch_country": null, 
           "bank": { 
              "name": "FACILITA IP S/A", 
              "ispb": "10789035" 
            }, 
           "account_type": "conta-corrente", 
           "account_number": "70017" 
            } 
         } 
      }
    }
}



// WEBPACK FOOTER //
// ./src/components/documentation/data/MarketplaceCollection/GettingBankAccountsAuthorized.js